import React, { useState, useEffect } from 'react';
import { dataApi } from "../../apis/dataApi";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import '../../css/fonts.css'
import '../../css/style.css'
import '../../css/bootstrap@5.3.0.min.css'
import bg from '../../assets/Walpapers/Wallpaper.png';
import logo from '../../assets/Logotipo/Logo_cetesninos_color.png';
import logoKZ from '../../assets/Logotipo/Logo_KZ.png'; import { useTranslation } from 'react-i18next';
import LogoCam from '../../assets/Logotipo/Logo_cetesninos_color.png';
import iconFlecha from '../../assets/Iconos/punta-de-flecha.png';
import { useNavigate } from 'react-router-dom';



function Finalizar() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [code, setCode] = useState('')
    const [selectedRadio, setSelectedRadio] = useState('invest');
    const handleClick = (e) => {
        e.preventDefault();
        navigate(`/`);
    }
    const { t, i18n } = useTranslation();
    var image_urbano = require(`../../assets/Imagenes/${t('inicio_imageUrbano')}`)


    return (
        <div className="cetes-background" style={{
            backgroundImage: `url(${bg})`,
            minHeight: '100svh',
            height: 'auto',
            overflowX: 'hidden'
        }}>
            <div className="cetes_inner_bkg_content" style={{
                minHeight: '100svh',
                height: 'auto',
                overflowX: 'hidden'
            }}>
                <div className="logos_CETES_junior">
                    <div
                        className="logo left-logo"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}
                    >
                        <img src={logo} alt="Logo CETES niños" style={{ height: 60, width: 'auto' }} />
                        <span style={{ fontSize: 18, whiteSpace: 'nowrap' }}>By KidZania</span>
                    </div>
                    <div className="logo right-logo">
                        <img src={logoKZ} alt="Logo organización KidZania" />
                    </div>
                </div>
                <div className="container-wrap-blocks-content">
                    <div className="welcome-blocks">
                        <div className="welcome-blocks-inner">
                            <div className="welcome-info">
                                <div className="info-txt-cetesJunior">
                                    <div className="title-intro">
                                        <h2>{t('end_title')}</h2>
                                    </div>
                                    <div className="text-descriptivo">
                                        <h4>{t('end_subtitle')}</h4>
                                    </div>
                                </div>
                                <div className="welcome-img-movil">
                                    <img src={image_urbano} alt="" />
                                </div>

                                <div className="info-inicio-sesion">
                                    <div className="registro-form-cetes-inner">
                                        <div className="btn-cetesJunior" >
                                            <button type="submit" onClick={handleClick} style={{ float: 'right' }}>{t('resumen_columna_finalizar')} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="welcome-img-desktop">
                                <img src={image_urbano} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading ? (
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div>
                    {/* Resto del código */}
                </div>
            )}
        </div>
    );
}

export default Finalizar;